module.exports = __webpack_public_path__ + "img/poorter_hotel-026.4005c69c.jpg";